import React, { useState, useEffect } from 'react'

import { 
    Auth 
} from 'aws-amplify'

// Form

import { 
    useForm
} from "react-hook-form"

import {
    ErrorText
} from '../../Styles/BaseStyles'

import { 
    SectionDiv, 
    HeaderDiv, 
    FormDiv, 
    SectionHeader, 
    SettingRowDiv,
    FullSettingDiv,
    SettingHeader,
    InputField,
    CancelButton,
    SaveButton,
    ConfirmationPhrase
} from  '../../Styles/Components/SettingsSectionStyles'

function PasswordSettingsSection(props){
    const [showActionButtons,setShowActionButtons] = useState(false)
    const [confirmUpdate,setConfirmUpdate] = useState(false)
    const [unmatched,setUnmatched] = useState(false)
    const [incorrectPswd,setIncorrectPswd] = useState(false)

    const defaults = {
        oldpassword: '',
        newpassword: '',
        confirmpassword: '',
    }

    const { register, handleSubmit, watch, errors, reset } = useForm({
        defaultValues: defaults,
        validateCriteriaMode: "all",
        mode: "onChange",
    })

    const allFields = watch()

    useEffect(() => {
        setIncorrectPswd(false)
        if(allFields.oldpassword === '' && allFields.newpassword === '' && allFields.confirmpassword === ''){
            reset()
            setShowActionButtons(false)
        }
        else{
            setShowActionButtons(true)
        }
        if(allFields.newpassword !== allFields.confirmpassword){
            setUnmatched(true)
        }
        else{
            setUnmatched(false)
        }
    },[allFields.oldpassword,allFields.newpassword,allFields.confirmpassword])

    useEffect(() => {
        if(confirmUpdate){
            const timeId = setTimeout(() => {
                setConfirmUpdate(false)
            }, 2000)
            return () => {
                clearTimeout(timeId)
            }
        }
    },[confirmUpdate,setConfirmUpdate])

    function save(data){
        if(!unmatched && !incorrectPswd){
            const oldpassword = data.oldpassword
            const newpassword = data.newpassword
            Auth.currentAuthenticatedUser()
                .then(user => {
                    return Auth.changePassword(user, oldpassword, newpassword);
                })
                .then(data => {
                    if(data === 'SUCCESS'){
                        setConfirmUpdate(true)
                    }
                })
                .catch(err => {
                    switch(err.code){
                        case 'NotAuthorizedException':
                            setIncorrectPswd(true)
                            break
                        default:
                            break
                    }
                })
        }
    }

    function cancel(){
        reset()
    }

    return (
        <SectionDiv id = 'password-settings-section'>
            <HeaderDiv>
                <SectionHeader>Update Password</SectionHeader>
            </HeaderDiv>
            <FormDiv>
                {!confirmUpdate && 
                    <>
                        <SettingRowDiv>
                            <FullSettingDiv>
                                <SettingHeader>Old Password:</SettingHeader>
                                <InputField 
                                    type="password" name="oldpassword" placeholder="" 
                                    ref={
                                        register({ 
                                            required: {
                                                value: true,
                                                message: 'required field'
                                            },
                                            minLength: {
                                                value: 8,
                                                message: 'below 8 character minimum'
                                            },
                                            maxLength: {
                                                value: 128,
                                                message: 'exceeds 128 character limit'
                                            },  
                                            pattern: {
                                                value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                                                message: 'must contain: 8 characters, uppercase letter, lowercase letter, number, and special character'
                                            } 
                                        })
                                    }
                                />
                                {errors['oldpassword'] != null && <ErrorText p={0} ml={0} mr={0} mt="0.25rem">{'*'+errors['oldpassword']['message']}</ErrorText>}
                                {errors['oldpassword'] == null && incorrectPswd && <ErrorText p={0} ml={0} mr={0} mt="0.25rem">*incorrect password</ErrorText>}
                            </FullSettingDiv>
                        </SettingRowDiv>
                        <SettingRowDiv>
                            <FullSettingDiv>
                                <SettingHeader>New Password:</SettingHeader>
                                <InputField 
                                    type="password" name="newpassword" placeholder="" 
                                    ref={
                                        register({ 
                                            required: {
                                                value: true,
                                                message: 'required field'
                                            },
                                            minLength: {
                                                value: 8,
                                                message: 'below 8 character minimum'
                                            },
                                            maxLength: {
                                                value: 128,
                                                message: 'exceeds 128 character limit'
                                            },  
                                            pattern: {
                                                value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                                                message: 'must contain: 8 characters, uppercase letter, lowercase letter, number, and special character'
                                            } 
                                        })
                                    }
                                />
                                {errors['newpassword'] != null && <ErrorText p={0} ml={0} mr={0} mt="0.25rem">{'*'+errors['newpassword']['message']}</ErrorText>}
                            </FullSettingDiv>
                        </SettingRowDiv>
                        <SettingRowDiv>
                            <FullSettingDiv>
                                <SettingHeader>Confirm New Password:</SettingHeader>
                                <InputField 
                                    type="password" name="confirmpassword" placeholder="" 
                                    ref={
                                        register({ 
                                            required: {
                                                value: true,
                                                message: 'required field'
                                            },
                                            minLength: {
                                                value: 8,
                                                message: 'below 8 character minimum'
                                            },
                                            maxLength: {
                                                value: 128,
                                                message: 'exceeds 128 character limit'
                                            },  
                                            pattern: {
                                                value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
                                                message: 'must contain: 8 characters, uppercase letter, lowercase letter, number, and special character'
                                            } 
                                        })
                                    }
                                />
                                {errors['confirmpassword'] != null && <ErrorText p={0} ml={0} mr={0} mt="0.25rem">{'*'+errors['confirmpassword']['message']}</ErrorText>}
                                {errors['confirmpassword'] == null && unmatched && <ErrorText p={0} ml={0} mr={0} mt="0.25rem">*passwords must match</ErrorText>}
                            </FullSettingDiv>
                        </SettingRowDiv>
                    </>
                }
                {confirmUpdate &&
                    <>
                        <SettingRowDiv>
                            <ConfirmationPhrase>Password Updated!</ConfirmationPhrase>
                        </SettingRowDiv>
                    </>
                }
                {showActionButtons &&
                    <SettingRowDiv>
                        <FullSettingDiv style={{'margin-top': '1rem'}}>
                            <CancelButton onClick={cancel}>Cancel</CancelButton>
                            <SaveButton onClick={handleSubmit(save)}>Save</SaveButton>
                        </FullSettingDiv>
                    </SettingRowDiv>
                }
            </FormDiv>
        </SectionDiv>
    )
}

export default PasswordSettingsSection